import formatCurrency from 'utils/formatCurrency';

export default function MostrarValor({
  label,
  valor,
  noFormat,
  unit,
  isDolar,
  isDestacado,
}: {
  label: string;
  valor: number | null;
  noFormat?: boolean;
  unit?: string;
  isDolar?: boolean;
  isDestacado: boolean | false;
}): JSX.Element {
  if (isDestacado)
    return (
      <tr style={{ backgroundColor: '#B0C4DE' }}>
        <td className="p-1">
          <h3>{label}:</h3>
        </td>
        <td className="p-1">
          <h3>
            <strong>
              {noFormat ? valor : formatCurrency(valor, 2, isDolar)} {unit}
            </strong>
          </h3>
        </td>
      </tr>
    );

  return (
    <tr>
      <td className="p-1">{label}:</td>
      <td className="p-1">
        <h5>
          <strong>
            {noFormat ? valor : formatCurrency(valor, 2, isDolar)} {unit}
          </strong>
        </h5>
      </td>
    </tr>
  );
}
